export default "__VITE_ASSET__Cehs2aKL__"